import '@eeacms/volto-columns-block/less/columns.less';

import React from 'react';
import ColumnVariations from '@eeacms/volto-columns-block/ColumnsBlock/ColumnVariations';
import EditBlockWrapper from '@eeacms/volto-columns-block/ColumnsBlock/EditBlockWrapper';
import { ColumnsBlockSchema } from '@eeacms/volto-columns-block/ColumnsBlock/schema';
import {
  empty,
  getColumns,
} from '@eeacms/volto-columns-block/ColumnsBlock/utils';
import { COLUMNSBLOCK } from '@eeacms/volto-columns-block/constants';
import { getStyle } from '@eeacms/volto-columns-block/Styles';
import { setUIState } from '@plone/volto/actions/form/form';
import { setSidebarTab } from '@plone/volto/actions/sidebar/sidebar';
import { BlockDataForm } from '@plone/volto/components/manage/Form';
import { BlocksForm } from '@plone/volto/components/manage/Form';
import BlocksToolbar from '@plone/volto/components/manage/Form/BlocksToolbar';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import {
  emptyBlocksForm,
  getBlocksLayoutFieldname,
} from '@plone/volto/helpers/Blocks/Blocks';
import config from '@plone/volto/registry';
import cx from 'classnames';
import isEmpty from 'lodash/isEmpty';
import without from 'lodash/without';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Grid } from 'semantic-ui-react';

import { default as messagesColumns } from '../../../../messages/columns';

import styles from './ColumnsBlock.module.less';
import { schemaExtender } from './schema';

const messages = defineMessages({
  labelColumn: {
    id: 'Column',
    defaultMessage: 'Column',
  },
  labelColumnsBlock: {
    id: 'Columns block',
    defaultMessage: 'Columns block',
  },
  labelToColSettings: {
    id: 'Go to Column settings',
    defaultMessage: 'Go to Column settings',
  },
});

/*
 * not pretty, there's a lot of render props passing, to please React
 * reconciliation algos
 *

ColumnsBlockEdit -> passes EditBlockWrapper into
  -> BlocksForm -> which passes (with EditBlock) into
    -> DragDropList -> which renders them all
*/
class ColumnsBlockEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      multiSelected: [],
      colSelections: {}, // selected block for each column
      showSidebar: false,
      activeColumn: null,
    };

    // This special variable is needed because of the onChangeField(block...) is
    // immediately followed by onChangeField(blocks_layout...), we want to save
    // this incoming information as data for the block, but because it is only
    // partial, we'll overwrite it in the second request. So we take advantage
    // of what happens between batched updates, we know that there will be two
    // calls, so even if we overwrite the state improperly on the first pass,
    // it will be fixed on the second pass if we have access to the proper
    // value from the first pass.
    //
    // We have volto-slate that does:
    // ReactDOM.unstable_batchedUpdates(() => {
    //    this.onChangeField(blocks, {})
    //    this.onChangeField(blocks_layout, {})
    // }
    // volto-slate needs to be neutral, to work in the main Volto form, but
    // also these types of subforms, so it should continue to use batched
    // onChangeField, as that works fine. So volto-columns-block needs that
    // blockState trick to overcome this. If there would be a onChangeBlocks or
    // onChangeFormData in Volto core, then BlocksForm could match that API
    // and this wouldn't be needed (together with the unstable_batchedUpdates
    // calls).
    this.blocksState = {};
  }

  createFrom = (initialData) => {
    const { gridCols, gridSize } = initialData;
    return {
      data: empty(gridCols.length),
      gridSize,
      gridCols,
    };
  };

  handleKeyDown = (
    e,
    index,
    block,
    node,
    {
      disableEnter = false,
      disableArrowUp = false,
      disableArrowDown = false,
    } = {},
  ) => {
    const hasblockActive = Object.keys(this.state.colSelections).length > 0;
    if (e.key === 'ArrowUp' && !disableArrowUp && !hasblockActive) {
      this.props.onFocusPreviousBlock(block, node);
      e.preventDefault();
    }
    if (e.key === 'ArrowDown' && !disableArrowDown && !hasblockActive) {
      this.props.onFocusNextBlock(block, node);
      e.preventDefault();
    }
    if (e.key === 'Enter' && !disableEnter && !hasblockActive) {
      this.props.onAddBlock(config.settings.defaultBlockType, index + 1);
      e.preventDefault();
    }
  };

  onChangeColumnSettings = (id, value) => {
    const { data, onChangeBlock, block } = this.props;
    const coldata = data.data;
    const formData = {
      ...data,
      data: {
        ...coldata,
        blocks: {
          ...coldata.blocks,
          [this.state.activeColumn]: {
            ...coldata.blocks?.[this.state.activeColumn],
            settings: {
              ...coldata.blocks?.[this.state.activeColumn]?.settings,
              [id]: value,
            },
          },
        },
      },
    };
    onChangeBlock(block, formData);
  };

  onChangeColumnData = (id, value, colId) => {
    const { data, onChangeBlock, block, onChangeField } = this.props;
    const coldata = data.data;
    // special handling of blocks and blocks_layout
    if (['blocks', 'blocks_layout'].indexOf(id) > -1) {
      this.blocksState[id] = value;
      onChangeBlock(block, {
        ...data,
        data: {
          ...coldata,
          blocks: {
            ...coldata.blocks,
            [colId]: {
              ...coldata.blocks?.[colId],
              ...this.blocksState,
            },
          },
        },
      });
    } else {
      onChangeField(id, value);
    }
  };

  onSelectBlock = (
    id,
    colId,
    colData,
    activeBlock,
    isMultipleSelection,
    event,
  ) => {
    let newMultiSelected = [];
    let selected = id;

    if (isMultipleSelection) {
      selected = null;
      const blocksLayoutFieldname = getBlocksLayoutFieldname(colData);

      const blocks_layout = colData[blocksLayoutFieldname].items;

      if (event.shiftKey) {
        const anchor =
          this.state.multiSelected.length > 0
            ? blocks_layout.indexOf(this.state.multiSelected[0])
            : blocks_layout.indexOf(activeBlock);
        const focus = blocks_layout.indexOf(id);

        if (anchor === focus) {
          newMultiSelected = [id];
        } else if (focus > anchor) {
          newMultiSelected = [...blocks_layout.slice(anchor, focus + 1)];
        } else {
          newMultiSelected = [...blocks_layout.slice(focus, anchor + 1)];
        }
      }

      if ((event.ctrlKey || event.metaKey) && !event.shiftKey) {
        if (this.state.multiSelected.includes(id)) {
          selected = null;
          newMultiSelected = without(this.state.multiSelected, id);
        } else {
          newMultiSelected = [...(this.state.multiSelected || []), id];
        }
      }
    }

    this.setState({
      multiSelected: newMultiSelected,
      colSelections: {
        // this invalidates selection in all other columns
        [colId]: selected,
      },
    });
  };

  getColumnsBlockSchema = () => {
    const variants = config.blocks.blocksConfig?.[COLUMNSBLOCK]?.variants || [];
    const schema = schemaExtender(
      ColumnsBlockSchema(this.props.intl),
      this.props.data,
    );
    const { data } = this.props;
    const { blocks_layout = {} } = data.data || {};
    const nrOfColumns = (blocks_layout?.items || []).length;
    const available_variants = variants.filter(
      ({ defaultData }) => defaultData?.gridCols?.length === nrOfColumns,
    );

    const equalGridCols = Array(nrOfColumns).fill(1);

    schema.properties.gridCols.choices = available_variants.map(
      ({ defaultData, title }) => [
        defaultData?.gridCols,
        title || this.props.intl.formatMessage(messagesColumns.equal),
      ],
    );

    if (available_variants.length === 0) {
      schema.properties.gridCols.isDisabled = true;
      schema.properties.gridCols.choices = [
        [equalGridCols, this.props.intl.formatMessage(messagesColumns.equal)],
      ];
      if (!data?.gridCols || data.gridCols.length === 0) {
        schema.properties.gridCols.default = equalGridCols;
      }
    }

    return schema;
  };

  componentDidUpdate(prevProps) {
    const variants = config.blocks.blocksConfig?.[COLUMNSBLOCK]?.variants || [];
    const cols = this.props.data.data?.blocks_layout?.items || [];
    const prevCols = prevProps.data.data?.blocks_layout?.items || [];

    const hasMissingGridCols =
      !this.props.data?.gridCols || this.props.data.gridCols.length === 0;

    if (cols.length > 0 && hasMissingGridCols) {
      return this.props.onChangeBlock(this.props.block, {
        ...this.props.data,
        gridSize: this.props.data?.gridSize || cols.length,
        gridCols: Array(cols.length).fill(1),
      });
    }

    const colNumChanged = cols.length !== prevCols.length;
    const initialLayoutSelection = prevCols.length === 0;
    const shouldUpdateLayout = colNumChanged && !initialLayoutSelection;

    if (shouldUpdateLayout) {
      const available_variants = variants.filter(
        ({ defaultData }) => defaultData?.gridCols?.length === cols.length,
      );
      const variant = available_variants?.[0];
      if (variant) {
        return this.props.onChangeBlock(this.props.block, {
          ...this.props.data,
          gridSize: variant.defaultData.gridSize,
          gridCols: variant.defaultData.gridCols,
        });
      }
    }

    // Sincroniza colSelections com gridSelected para selecionar o bloco que deu erro corretamente
    if (
      this.props.gridSelected &&
      this.props.gridSelected !== prevProps.gridSelected
    ) {
      // Procura em qual coluna está o bloco selecionado
      const coldata = this.props.data.data;
      if (coldata && coldata.blocks) {
        const colId = Object.keys(coldata.blocks).find((colId) => {
          const col = coldata.blocks[colId];
          return col && col.blocks && col.blocks[this.props.gridSelected];
        });
        if (colId) {
          this.setState({
            colSelections: {
              [colId]: this.props.gridSelected,
            },
            multiSelected: [],
          });
          if (this.props.clearGridSelected) {
            this.props.clearGridSelected();
          }
        }
      }
    }
  }

  render() {
    const { block, data, onChangeBlock, pathname, selected, manage } =
      this.props;

    const metadata = this.props.metadata || this.props.properties;
    const {
      gridCols,
      gridSize,
      fullWidth = 'none',
      useBackground,
      backgroundColor,
      increasePadding,
    } = data;
    const coldata = data.data;
    const columnList = getColumns(coldata);

    const colSelections = this.state.colSelections;
    const selectedCol =
      Object.keys(colSelections).length > 0
        ? Object.keys(colSelections)[0]
        : null;
    const selectedColData = selectedCol
      ? coldata?.blocks?.[selectedCol] || null
      : null;
    const selectedBlock = selectedCol ? colSelections[selectedCol] : null;

    const { gridSizes, variants } = config.blocks.blocksConfig[COLUMNSBLOCK];
    const isInitialized = data?.data && Object.keys(data?.data).length > 0;

    const normalizedGridCols =
      gridCols && gridCols.length > 0
        ? gridCols
        : Array(columnList.length).fill(1);
    const normalizedGridSize = gridSize || columnList.length;
    const normalizedBackgroundColor =
      backgroundColor === 'darkBlue' ? 'darkBlue' : 'grey';
    const hasBackground = !!useBackground;

    const gridClasses = cx('column-grid', 'columns-wrapper', {
      [styles.back]: hasBackground && normalizedBackgroundColor === 'grey',
      [styles.backDarkBlue]:
        hasBackground && normalizedBackgroundColor === 'darkBlue',
      [styles.none]: fullWidth === 'none',
      [styles.full]: fullWidth === 'background',
      [styles.cont]: fullWidth === 'all',
      [styles.pad]: increasePadding,
    });

    // Verifica se todas as colunas têm o mesmo tamanho
    const equalColumns = normalizedGridCols.every(
      (col) => col === normalizedGridCols[0],
    );

    return (
      <div
        role="presentation"
        className="columns-block"
        onKeyDown={(e) => {
          this.handleKeyDown(
            e,
            this.props.index,
            this.props.block,
            this.props.blockNode.current,
          );
        }}
        // The tabIndex is required for the keyboard navigation
        /* eslint-disable jsx-a11y/no-noninteractive-tabindex */
        tabIndex={-1}
      >
        {data.coldata ? 'old style columns block, safe to remove it' : ''}
        {!isInitialized ? (
          <div className="col-variations text-down-01">
            <ColumnVariations
              variants={variants.filter((variant) => variant.common)}
              data={data}
              onChange={(initialData) => {
                onChangeBlock(block, {
                  ...data,
                  ...this.createFrom(initialData),
                });
              }}
            />
          </div>
        ) : (
          <>
            <div
              className="columns-header"
              onClick={() => {
                this.setState({
                  showSidebar: true,
                  colSelections: {},
                });
                this.props.setSidebarTab(1);
              }}
              aria-hidden="true"
            >
              {data.title || (
                <FormattedMessage
                  id="Columns block"
                  defaultMessage="Columns block"
                />
              )}
            </div>
            <Grid
              columns={
                equalColumns ? normalizedGridCols.length : normalizedGridSize
              }
              className={gridClasses}
              stackable
              reversed={data?.reverseWrap ? 'mobile' : undefined}
            >
              {columnList.map(([colId, column], index) => (
                <Grid.Column
                  className={cx(
                    'block-column',
                    data?.data?.blocks?.[colId]?.settings?.column_class,
                  )}
                  key={colId}
                  {...(!equalColumns &&
                    (gridSizes[normalizedGridCols[index]] ||
                      normalizedGridCols[index]))}
                  {...getStyle(data?.data?.blocks?.[colId]?.settings || {})}
                >
                  <BlocksForm
                    errors={this.props.errors}
                    blocksErrors={this.props.blocksErrors}
                    key={colId}
                    title={data?.placeholder}
                    description={data?.instructions?.data}
                    manage={manage}
                    allowedBlocks={data?.allowedBlocks}
                    metadata={metadata}
                    properties={{
                      ...metadata,
                      ...(isEmpty(column) ? emptyBlocksForm() : column),
                    }}
                    isMainForm={false}
                    disableEvents={true}
                    selectedBlock={colSelections[colId] || null}
                    onSelectBlock={(id, selected, e) => {
                      const isMultipleSelection = e
                        ? e.shiftKey || e.ctrlKey || e.metaKey
                        : false;
                      this.onSelectBlock(
                        id,
                        colId,
                        selectedColData,
                        selectedBlock,
                        selectedCol !== colId || selectedBlock === id
                          ? false
                          : isMultipleSelection,
                        e,
                      );
                    }}
                    onChangeFormData={(newFormData) => {
                      onChangeBlock(block, {
                        ...data,
                        data: {
                          ...coldata,
                          blocks: {
                            ...coldata.blocks,
                            [colId]: {
                              ...coldata.blocks?.[colId],
                              blocks: newFormData.blocks,
                              blocks_layout: newFormData.blocks_layout,
                            },
                          },
                        },
                      });
                    }}
                    onChangeField={(id, value) =>
                      this.onChangeColumnData(id, value, colId)
                    }
                    pathname={pathname}
                  >
                    {({ draginfo }, editBlock, blockProps) => (
                      <EditBlockWrapper
                        draginfo={draginfo}
                        blockProps={blockProps}
                        multiSelected={this.state.multiSelected.includes(
                          blockProps.block,
                        )}
                      >
                        {editBlock}
                      </EditBlockWrapper>
                    )}
                  </BlocksForm>
                </Grid.Column>
              ))}
            </Grid>
          </>
        )}

        {selected && selectedColData ? (
          <BlocksToolbar
            formData={selectedColData}
            selectedBlock={selectedBlock}
            selectedBlocks={this.state.multiSelected}
            onChangeBlocks={(newBlockData) => {
              onChangeBlock(block, {
                ...data,
                data: {
                  ...coldata,
                  blocks: {
                    ...coldata.blocks,
                    [selectedCol]: { ...selectedColData, ...newBlockData },
                  },
                },
              });
            }}
            onSetSelectedBlocks={(blockIds) => {
              this.setState({ multiSelected: blockIds });
            }}
            onSelectBlock={this.onSelectBlock}
          />
        ) : (
          ''
        )}

        {Object.keys(this.state.colSelections).length === 0 &&
        !data?.readOnlySettings ? (
          <SidebarPortal selected={selected}>
            <BlockDataForm
              {...this.props}
              schema={this.getColumnsBlockSchema()}
              title={this.props.intl.formatMessage(messages.labelColumnsBlock)}
              onChangeField={(id, value) => {
                onChangeBlock(block, {
                  ...data,
                  [id]: value,
                });
              }}
              formData={data}
            />
          </SidebarPortal>
        ) : (
          ''
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  gridSelected: state.form?.ui?.gridSelected,
});

const mapDispatchToProps = (dispatch) => ({
  setSidebarTab: (tab) => dispatch(setSidebarTab(tab)),
  clearGridSelected: () => dispatch(setUIState({ gridSelected: null })),
});

export default compose(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(ColumnsBlockEdit);
